import { makeObservable, observable, action } from "mobx";
import { IChatRecvMessage, IChatSendMessage } from "../chat/types";
import { IGuessItem } from "./types";
import { getGuessList } from "../../services/guess";

export default class Guess {
  @observable question: IChatSendMessage[] | null = null;
  @observable answer: IChatRecvMessage[] | null = null;

  @observable.ref guessList: IGuessItem[] = [];

  @observable loading: boolean = false;

  private _cancelRequest: boolean = false; // 用于取消请求处理

  constructor() {
    makeObservable(this);
  }

  setQuestion(question: IChatSendMessage[] | null) {
    this.question = question;
  }

  setAnswer(answer: IChatRecvMessage[] | null) {
    this.answer = answer;
  }

  setGuessList(guessList: IGuessItem[]) {
    this.guessList = guessList;
  }

  setLoading(loading: boolean) {
    this.loading = loading;
  }

  setCancelRequest(cancel: boolean) {
    this._cancelRequest = cancel;
  }

  async getGuessList(
    send_msg: IChatSendMessage[],
    recv_msg: IChatRecvMessage[],
    session_id: string,
  ) {
    this.setLoading(true);
    try {
      const guessOb = await getGuessList({ send_msg, recv_msg, session_id });
      // 如果请求被取消了，就不处理返回的数据
      if (this._cancelRequest) {
        this.setCancelRequest(false);
        return;
      }
      this.setAnswer(recv_msg);
      this.setQuestion(send_msg);
      this.setGuessList(guessOb.message.list);
    } catch (error) {
      console.error("Failed to fetch guess list", error);
    } finally {
      this.setLoading(false);
    }
  }

  stopGuessList() {
    this.setAnswer(null);
    this.setQuestion(null);
    this.setGuessList([]);
    if (this.loading) {
      this.setCancelRequest(true);
      this.setLoading(false);
    }
  }
}
